export const getImage = ({ images, type }) => {
	return images?.[type]?.[0]?.url || '';
};
